import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { LoginPage } from './login-page/login-page.component';
import { HomePage } from './home-page/home-page.component';
import { JjsvHeader } from '../components/jjsv-header/jjsv-header.component';
import { JjsvFooter } from '../components/jjsv-footer/jjsv-footer.component';
import { PurchaseOrdersPage } from './purchase-orders-page/purchase-orders-page.component';
import { ReviewOrdersPage } from './review-orders-page/review-orders-page.component';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        LoginComponent: {
          component: LoginPage,
        },
        HomePageComponent: {
          component: HomePage,
        },
        PurchaseOrdersComponent: {
          component: PurchaseOrdersPage,
        },
        ReviewOrderComponent: {
          component: ReviewOrdersPage,
        },
      },
    }),
  ],
})
export class PagesModule {}
